var _defs, _g, _rect, _path, _line, _rect2, _path2, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupvideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 400,
    viewBox: "0 0 800 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "occlusion-mask",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 400,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 140,
    width: 280,
    height: 180,
    rx: 15,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 140,
    width: 280,
    height: 180,
    rx: 15,
    fill: "black"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#occlusion-mask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 40,
    width: 400,
    height: 260,
    rx: 20,
    stroke: "#00AEEF",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 300 L320 360 H480 L450 300",
    stroke: "#00AEEF",
    strokeWidth: 12,
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 380,
    x2: 520,
    y2: 380,
    stroke: "#00AEEF",
    strokeWidth: 12,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 140,
    width: 280,
    height: 180,
    rx: 15,
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 320 L115 360 H185 L170 320",
    stroke: "#00AEEF",
    strokeWidth: 12,
    strokeLinejoin: "round",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 375,
    x2: 210,
    y2: 375,
    stroke: "#00AEEF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 140,
    width: 280,
    height: 180,
    rx: 15,
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M610 320 L595 360 H665 L650 320",
    stroke: "#00AEEF",
    strokeWidth: 12,
    strokeLinejoin: "round",
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 570,
    y1: 375,
    x2: 690,
    y2: 375,
    stroke: "#00AEEF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupvideoIcon);
export default __webpack_public_path__ + "static/media/groupvideo-icon.71987563a90b11f6b560825ccdfc3aa3.svg";
export { ForwardRef as ReactComponent };